import React from 'react';
import AnimatedSection from '../components/AnimatedSection';

const About = () => {
  return (
    <>
      <section className="about-section">
        {/* Animated Background */}
        <div className="animated-background">
          <div className="gradient-orb-1"></div>
          <div className="gradient-orb-2"></div>
          <div className="gradient-orb-3"></div>
          <div className="floating-shapes">
            {[...Array(20)].map((_, i) => (
              <div key={i} className="shape" style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 15}s`,
                animationDuration: `${10 + Math.random() * 15}s`,
                width: `${20 + Math.random() * 60}px`,
                height: `${20 + Math.random() * 60}px`,
                opacity: 0.03 + Math.random() * 0.05
              }}></div>
            ))}
          </div>
        </div>

        <div className="container">
          {/* Main Content with Side Logo */}
          <div className="about-main">
            {/* Left Side - Large Logo Image */}
            <AnimatedSection animation="fade-left" delay={100}>
              <div className="logo-side">
                <div className="logo-container">
                  <div className="logo-glow"></div>
                  <img 
                    src="https://vtechcoders.com/team/VTECH-LOGO-1.PNG" 
                    alt="VTECH CODERS Logo" 
                    className="about-logo"
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/400x400?text=VTECH+CODERS';
                    }}
                  />
                  <div className="logo-particles">
                    {[...Array(12)].map((_, i) => (
                      <div key={i} className="logo-particle" style={{
                        animationDelay: `${i * 0.5}s`,
                        top: `${50 + Math.sin(i) * 30}%`,
                        left: `${50 + Math.cos(i) * 30}%`
                      }}></div>
                    ))}
                  </div>
                </div>
                <div className="logo-stats">
                  <div className="stat-item">
                    <span className="stat-number">50+</span>
                    <span className="stat-label">Projects Completed</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">100+</span>
                    <span className="stat-label">Happy Clients</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">14+</span>
                    <span className="stat-label">Years Experience</span>
                  </div>
                </div>
              </div>
            </AnimatedSection>

            {/* Right Side - Content */}
            <div className="content-side">
              <AnimatedSection animation="fade-right" delay={200}>
                <div className="section-badge">
                  <i className="fas fa-code"></i>
                  <span>About Us</span>
                </div>
                <h1 className="about-title">VTECH CODERS</h1>
                <div className="about-description">
                  <p>VTECH CODERS, an offshore IT outsourcing company in India, provides a range of IT outsourcing services and solutions to enable companies develop challenging and innovative software products as well as run their day-to-day operations.</p>
                  
                  <div className="highlight-text">
                    <i className="fas fa-quote-left"></i>
                    <p>Our mission is to alter the dynamics of the software industry by providing trusted, supportive and quality software development services to clients that view our partnership as a strategic driver for their success.</p>
                  </div>
                  
                  <p>When we take on your project, we take the stewardship of the project with you in the director's seat. As stewards of your project, we consider ourselves successful not when we deliver your final product but when the product meets your business objectives and that is our vision.</p>
                </div>
                
                <div className="values-tags">
                  <div className="value-tag">
                    <i className="fas fa-brain"></i>
                    <span>AI-driven approach</span>
                  </div>
                  <div className="value-tag">
                    <i className="fas fa-globe"></i>
                    <span>Global footprint</span>
                  </div>
                  <div className="value-tag">
                    <i className="fas fa-handshake"></i>
                    <span>360° partnership</span>
                  </div>
                </div>
              </AnimatedSection>
            </div>
          </div>

          {/* Why Us & Core Values Section */}
          <div className="cards-section">
            <div className="cards-grid">
              <AnimatedSection animation="scale-up" delay={300}>
                <div className="info-card why-us-card">
                  <div className="card-icon">
                    <i className="fas fa-chart-line"></i>
                  </div>
                  <h3>Why Choose Us</h3>
                  <p>More than just a "development house", VTECH CODERS will work with your company to develop a strategy that is specific to your industry to give your application the best chance of success. Building an application is more than just development; it needs to strike a balance between meeting your business needs while being compelling for your audience.</p>
                  <div className="card-footer">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </div>
                </div>
              </AnimatedSection>
              
              <AnimatedSection animation="scale-up" delay={400}>
                <div className="info-card values-card">
                  <div className="card-icon">
                    <i className="fas fa-heart"></i>
                  </div>
                  <h3>Our Core Values</h3>
                  <div className="values-list">
                    <div className="value-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Integrity - The foundation of all our actions</span>
                    </div>
                    <div className="value-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Innovation - Constantly pushing boundaries</span>
                    </div>
                    <div className="value-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Excellence - Delivering beyond expectations</span>
                    </div>
                    <div className="value-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Collaboration - Together we achieve more</span>
                    </div>
                    <div className="value-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Customer First - Your success is our success</span>
                    </div>
                  </div>
                </div>
              </AnimatedSection>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        /* Main Section */
        .about-section {
          padding: 5rem 0;
          position: relative;
          overflow: hidden;
          min-height: 100vh;
        }
        
        /* Animated Background */
        .animated-background {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 0;
          overflow: hidden;
        }
        
        .gradient-orb-1,
        .gradient-orb-2,
        .gradient-orb-3 {
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
          animation: floatOrb 20s ease-in-out infinite;
        }
        
        .gradient-orb-1 {
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(59, 130, 246, 0.3), rgba(139, 92, 246, 0.2));
          top: -250px;
          left: -250px;
          animation-delay: 0s;
        }
        
        .gradient-orb-2 {
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, rgba(139, 92, 246, 0.25), rgba(236, 72, 153, 0.15));
          bottom: -300px;
          right: -300px;
          animation-delay: -5s;
        }
        
        .gradient-orb-3 {
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(6, 182, 212, 0.2), rgba(59, 130, 246, 0.15));
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation-delay: -10s;
        }
        
        @keyframes floatOrb {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          33% {
            transform: translate(50px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-50px, 50px) scale(0.9);
          }
        }
        
        /* Floating Shapes */
        .floating-shapes {
          position: absolute;
          width: 100%;
          height: 100%;
        }
        
        .shape {
          position: absolute;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          border-radius: 50%;
          animation: floatShape linear infinite;
        }
        
        @keyframes floatShape {
          0% {
            transform: translateY(100vh) rotate(0deg);
          }
          100% {
            transform: translateY(-100vh) rotate(360deg);
          }
        }
        
        /* Main Layout */
        .about-main {
          display: grid;
          grid-template-columns: 1fr 1.5fr;
          gap: 4rem;
          align-items: center;
          margin-bottom: 4rem;
          position: relative;
          z-index: 2;
        }
        
        /* Logo Side */
        .logo-side {
          text-align: center;
        }
        
        .logo-container {
          position: relative;
          margin-bottom: 2rem;
        }
        
        .logo-glow {
          position: absolute;
          inset: -20px;
          background: radial-gradient(circle, rgba(59, 130, 246, 0.4), transparent);
          border-radius: 50%;
          animation: pulseGlow 3s ease-in-out infinite;
        }
        
        @keyframes pulseGlow {
          0%, 100% {
            opacity: 0.5;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.1);
          }
        }
        
        .about-logo {
          width: 100%;
          max-width: 350px;
          height: auto;
          position: relative;
          z-index: 2;
          border-radius: 30px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
          transition: transform 0.4s ease;
          animation: floatLogo 4s ease-in-out infinite;
        }
        
        @keyframes floatLogo {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        
        .about-logo:hover {
          transform: scale(1.02) translateY(-5px);
        }
        
        .logo-particles {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
        }
        
        .logo-particle {
          position: absolute;
          width: 4px;
          height: 4px;
          background: #3b82f6;
          border-radius: 50%;
          animation: particleOrbit 3s linear infinite;
        }
        
        @keyframes particleOrbit {
          0% {
            transform: rotate(0deg) translateX(80px) rotate(0deg);
            opacity: 0;
          }
          50% {
            opacity: 0.8;
          }
          100% {
            transform: rotate(360deg) translateX(80px) rotate(-360deg);
            opacity: 0;
          }
        }
        
        /* Logo Stats */
        .logo-stats {
          display: flex;
          justify-content: center;
          gap: 2rem;
          margin-top: 1.5rem;
        }
        
        .stat-item {
          text-align: center;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          padding: 0.8rem 1.2rem;
          border-radius: 50px;
          border: 1px solid rgba(59, 130, 246, 0.3);
        }
        
        .stat-number {
          display: block;
          font-size: 1.5rem;
          font-weight: 800;
          color: #3b82f6;
        }
        
        .stat-label {
          font-size: 0.7rem;
          color: #64748b;
        }
        
        /* Content Side */
        .content-side {
          position: relative;
        }
        
        .section-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(139, 92, 246, 0.2));
          padding: 0.5rem 1rem;
          border-radius: 50px;
          margin-bottom: 1rem;
          font-size: 0.85rem;
          font-weight: 600;
          color: #3b82f6;
        }
        
        .about-title {
          font-size: 2.8rem;
          font-weight: 800;
          margin-bottom: 1.5rem;
          background: linear-gradient(135deg, #1e293b, #3b82f6);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        
        .about-description p {
          color: #475569;
          line-height: 1.8;
          margin-bottom: 1rem;
          font-size: 1rem;
        }
        
        .highlight-text {
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.05), rgba(139, 92, 246, 0.05));
          padding: 1.5rem;
          border-radius: 16px;
          margin: 1.5rem 0;
          border-left: 4px solid #3b82f6;
          position: relative;
        }
        
        .highlight-text i {
          position: absolute;
          top: -10px;
          left: 10px;
          font-size: 2rem;
          color: #3b82f6;
          opacity: 0.3;
        }
        
        .highlight-text p {
          margin-bottom: 0;
          font-style: italic;
          color: #1e293b;
        }
        
        /* Values Tags */
        .values-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          margin-top: 2rem;
        }
        
        .value-tag {
          display: flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1));
          padding: 0.6rem 1.2rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 500;
          color: #3b82f6;
          transition: all 0.3s ease;
        }
        
        .value-tag:hover {
          transform: translateY(-2px);
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(139, 92, 246, 0.2));
        }
        
        /* Cards Section */
        .cards-section {
          position: relative;
          z-index: 2;
          margin-top: 2rem;
        }
        
        .cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 2rem;
        }
        
        .info-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 24px;
          padding: 2rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(59, 130, 246, 0.1);
          transition: all 0.4s ease;
        }
        
        .info-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          border-color: rgba(59, 130, 246, 0.3);
        }
        
        .card-icon {
          width: 70px;
          height: 70px;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1));
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.5rem;
        }
        
        .card-icon i {
          font-size: 2rem;
          color: #3b82f6;
        }
        
        .info-card h3 {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #1e293b;
        }
        
        .info-card p {
          color: #64748b;
          line-height: 1.6;
          margin-bottom: 1rem;
        }
        
        .card-footer {
          margin-top: 1rem;
          display: flex;
          gap: 5px;
          color: #fbbf24;
        }
        
        .values-list {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
        }
        
        .value-item {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 0.9rem;
          color: #475569;
        }
        
        .value-item i {
          color: #10b981;
        }
        
        /* Responsive */
        @media (max-width: 968px) {
          .about-main {
            grid-template-columns: 1fr;
            gap: 2rem;
            text-align: center;
          }
          
          .about-title {
            font-size: 2rem;
          }
          
          .values-tags {
            justify-content: center;
          }
          
          .logo-stats {
            flex-wrap: wrap;
          }
          
          .cards-grid {
            grid-template-columns: 1fr;
          }
        }
        
        @media (max-width: 768px) {
          .about-section {
            padding: 3rem 0;
          }
          
          .about-logo {
            max-width: 250px;
          }
        }
        
        /* Dark Mode */
        @media (prefers-color-scheme: dark) {
          .info-card {
            background: rgba(30, 41, 59, 0.95);
          }
          
          .info-card h3 {
            color: #f1f5f9;
          }
          
          .info-card p {
            color: #94a3b8;
          }
          
          .about-description p {
            color: #cbd5e1;
          }
          
          .highlight-text p {
            color: #e2e8f0;
          }
          
          .highlight-text {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1));
          }
          
          .value-item {
            color: #cbd5e1;
          }
        }
      `}</style>
    </>
  );
};

export default About;

